import React from 'react';

import Layout from '../components/Layout';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
 
import a from '../assets/images/a-xx-001-art.jpg';
import b from '../assets/images/a-xx-002-art.jpg';
import c from '../assets/images/a-xx-003-art.jpg';
import d from '../assets/images/a-xx-004-art.jpg';
import e from '../assets/images/a-xx-005-art.jpg';
import f from '../assets/images/a-xx-006-art.jpg';
import g from '../assets/images/a-xx-007-art.jpg';
import h from '../assets/images/a-xx-008-art.jpg';
import i from '../assets/images/a-xx-009-art.jpg';
import j from '../assets/images/a-xx-010-art.jpg';




const pillars = [
  [
    {
      img: a,
      title:'Kuttuvilukku',
      text: 'Standing oil lamps, kuttuvilakku. A standing metal oil lamp kept in the temple, shrine room or home. Part of temple and shrine altars, the standing lamp is sometimes worshiped as the divine light, Parashakti or Parajyoti. Returning from the temple and lighting one’s kuttuvilakku courts the accompanying devas to remain in the home and channels the vibration of the temple sanctum sanctorum into the home shrine. Called dipastambha in Sanskrit.'
    },
    {
      img: b,
      title:'Aum',
      text: 'The mystic syllable of Hinduism, placed at the beginning of most sacred writings. Aum is the primary, or mula mantra, and often precedes other mantras. It may be safely used for chanting and japa by anyone of any religion. Its three letters represent the three worlds and the powers of creation, preservation and destruction.'
    },
    {
      img: c,
      title:'Trident',
      text: 'Trident, called trisula in Sanskrit. A three-pronged spear or trident wielded by Lord Siva and certain Saivite ascetics. Also held by loving Ganesha, it symbolizes God’s three fundamental shaktis or powers—icchha (desire, will, love), kriya (action) and jnana (wisdom).'
    },
    {
      img: d,
      title:'Damaru',
      text: 'Damaru is the thin-waisted rattle drum held by Siva Nataraja. It is the symbol of Divine Creation, which begins with the soundless sound, paranada, whence arises the mantra Aum.'
    }
  ],
  
  [
    {
      img: e,
      title:'Yoga Pada',
      text: 'Yoga pada. Here the hands are held in the meditative mudra, This signifies meditation, or yoga, the third of the successive stages in spiritual unfoldment in Saiva Siddhanta, wherein the ultimate goal is to go within and attain Self Realization.'
    },
    {
      img: f,
      title:'Charya Pada',
      text: ' Chariya pada is the stage of religious action; worship. Here the devotee engages in simple forms of service and character building. It is the first of four progressive stages of maturation on the Saiva Siddhanta path of attainment.'
    },
    {
      img: g,
      title:'Kriya Pada',
      text: 'This is the kriya pada, the “worship stage” on the San Marga. During this part of evolution the devotee is engaged in puja, religious actions, rites and ceremonies.'
    },
    {
      img: h,
      title:'Jnana Pada',
      text: 'Jnana is the stage of wisdom, the fourth and final stage on the San Marga path to enlightenment. Here the satguru is sharing the knowledge of Siva with two disciples.'
    }
   ],

    [
      {
        img: i,
        title:'Namah Sivaya',
        text: 'Namasivaya. This is the holy five-letter mantra chanted daily by devout Saivites, once initiated into the mantra. It literally means “Praise to the Great God Siva.”'
      },
      {
        img: j,
        title:'Siva Dhvajapalika',
        text: 'Dhvajapalika. This is one of the two dvaja palikas who guard the entrance to a temple sanctum. His hand is indicating Siva is within, and is inviting pilgrims to draw closer to God.'
      },
      {
        img: '',
        title:'',
        text: ''
      },
      {
        img: '',
        title:'',
        text: ''
      }


   ]
];
 

const Pillar01 = () => (

  
  <Layout fullMenu>
    <article id="main">
      <header style={{marginBottom:0}}>
      
        <h2 style={{color:'#dd7137'}}>Pillar One</h2>
        <p>Artwork by A. Manivelu </p>
      </header>
      

    

<section className=" style4">     
        <div  > 
 
<div style={{maxWidth:500, padding: 10,marginLeft:'auto', marginRight:'auto'}}>
<h4 style={{textAlign:'center'}}>Top</h4>
         <Carousel showArrows={false}>
                <div>
                    <img className="image" src={pillars[0][0].img} />
                    <h4>NORTH FACE: <br/>{pillars[0][0].title}</h4>
                    <p>{pillars[0][0].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[0][1].img} />
                  <h4>EAST FACE:  <br/>{pillars[0][1].title}</h4>
                    <p>{pillars[0][1].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[0][2].img} />
                  <h4>SOUTH FACE:  <br/>{pillars[0][2].title}</h4>
                    <p>{pillars[0][2].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[0][3].img} />
                  <h4>WEST FACE:  <br/>{pillars[0][3].title}</h4>
                    <p>{pillars[0][3].text}</p>
                </div>
            </Carousel> 


            <h4 style={{textAlign:'center'}}>Middle</h4>
         <Carousel showArrows={false}>
         <div>
                    <img className="image" src={pillars[1][0].img} />
                    <h4>NORTH FACE: <br/>{pillars[1][0].title}</h4>
                    <p>{pillars[1][0].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[1][1].img} />
                  <h4>EAST FACE:  <br/>{pillars[1][1].title}</h4>
                    <p>{pillars[1][1].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[1][2].img} />
                  <h4>SOUTH FACE:  <br/>{pillars[1][2].title}</h4>
                    <p>{pillars[1][2].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[1][3].img} />
                  <h4>WEST FACE:  <br/>{pillars[1][3].title}</h4>
                    <p>{pillars[1][3].text}</p>
                </div>
            </Carousel> 
            <h4 style={{textAlign:'center'}}>Bottom</h4>
         <Carousel showArrows={false}>
         <div>
                    <img className="image" src={pillars[2][0].img} />
                    <h4>NORTH FACE: <br/>{pillars[2][0].title}</h4>
                    <p>{pillars[2][0].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[2][1].img} />
                  <h4>EAST FACE:  <br/>{pillars[2][1].title}</h4>
                    <p>{pillars[2][1].text}</p>
                </div>
                 
            </Carousel> 

            </div>

 
      

        </div>
      </section>
      
    </article>
  </Layout>
);

export default Pillar01;
